import TvGuideStore from "core/providers/tv-guide.store";
import { observer } from "mobx-react-lite";
import TvGuideHeader from "./tv-guide-header";
import Layout from "./layout";
import Loader from "./loader/loader";

type TvGuideProps = {
    store: TvGuideStore
}

const TvGuide = observer((props: TvGuideProps) => {
    const { store } = props;

    if (!store.hasScheduleData) {
        return <Loader />
    }

    return <>
        <TvGuideHeader />
        <div className="tv-guide">
            <Layout />
        </div>
    </>
});

export default TvGuide;